import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'grading-category',
    pluginName: 'ADMIN',
    entityName: 'GRADING_CATEGORY',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch grading categories action creators
export const fetchGradingCategoriesInit = () => {
    return crudActions.fetchInit();
};
export const fetchGradingCategoriesStart = () => {
    return crudActions.fetchStart();
};
export const fetchGradingCategoriesSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchGradingCategoriesFail = () => {
    return crudActions.fetchFail();
};
export const fetchGradingCategoriesCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchGradingCategoriesStart());
        try {
            let countRes = await rest.post("/grading-category/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchGradingCategoriesSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchGradingCategoriesFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch grading categories."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchGradingCategoriesFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch grading categories."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchGradingCategories = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchGradingCategoriesStart());
        try {
            let listRes = await rest.post("/grading-category/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchGradingCategoriesSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchGradingCategoriesFail());
            return []

        } catch (error) {
            dispatch(fetchGradingCategoriesFail());
            return []
        }
    }
}

// Load grading category action creators
export const loadGradingCategoryInit = () => {
    return crudActions.loadInit();
};
export const loadGradingCategoryStart = () => {
    return crudActions.loadStart();
};
export const loadGradingCategorySuccess = loadedGradingCategory => {
    return crudActions.loadSuccess(loadedGradingCategory);
};
export const loadGradingCategoryFail = error => {
    return crudActions.loadFail(error);
};
export const loadGradingCategory = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

// Create grading category action creators
export const createGradingCategoryInit = () => {
    return crudActions.createInit();
};
export const createGradingCategoryStart = () => {
    return crudActions.createStart();
};
export const createGradingCategorySuccess = createdGradingCategory => {
    return crudActions.createSuccess(createdGradingCategory);
};
export const createGradingCategoryFail = error => {
    return crudActions.createFail(error);
};

export const createGradingCategory = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createGradingCategoryStart());
        try {
            let res = await rest.post('/grading-category/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created grading category.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createGradingCategoryFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create grading category."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create grading category."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createGradingCategoryFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Edit grading category action creators
export const editGradingCategoryInit = () => {
    return crudActions.editInit();
};
export const editGradingCategoryStart = () => {
    return crudActions.editStart();
};
export const editGradingCategorySuccess = editedGradingCategory => {
    return crudActions.editSuccess(editedGradingCategory);
};
export const editGradingCategoryFail = error => {
    return crudActions.editFail(error);
};

export const editGradingCategory = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editGradingCategoryStart());
        try {
            let res = await rest.post('/grading-category/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated grading category.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editGradingCategoryFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit grading category."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit grading category."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editGradingCategoryFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete grading categories action creators
export const bulkDeleteGradingCategoriesInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteGradingCategoriesStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteGradingCategoriesSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteGradingCategoriesFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteGradingCategories = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteGradingCategoriesStart());
        try {
            let res = await rest.post('/grading-category/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteGradingCategoriesSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted grading categories.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteGradingCategoriesFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete grading categories."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete grading categories."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteGradingCategoriesFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};